const OnEscape = function (ev) {
  if (ev.keyCode === 27) {
    this.addPermission.hideModal()
  }
}

export default OnEscape
